<button
  ht-select-button
  size="small"
  data-testid="inbox-sort"
  (click)="toggleDropdown()"
>
  <i
    class="fa-solid"
    [class.fa-arrow-up-short-wide]="sortDirection() === 'asc'"
    [class.fa-arrow-down-wide-short]="sortDirection() !== 'asc'"
  ></i>
  {{ label() }}
  <i
    class="fa-solid"
    [class.fa-chevron-up]="isDropdownOpen"
    [class.fa-chevron-down]="!isDropdownOpen"
  ></i>
</button>
<div [class.opened]="isDropdownOpen" class="dropdown-menu">
  @for (
    item of options();
    track item.key.sortBy + ':' + item.key.sortDirection
  ) {
    <div
      class="dropdown-menu-item"
      [attr.data-testid]="item.key.sortBy + ':' + item.key.sortDirection"
      (click)="onClickSortOption(item)"
      [class.active]="item.selected"
    >
      {{ item.label }}
    </div>
  }
</div>
